import axios from 'axios';
import { FC, useEffect } from 'react'
import { BarLoader } from 'react-spinners';
import Endpoints from '../../enums/Endpoints';
import { ClearTokens } from './components/SsoComponent';

const Logout: FC = () => {
    const signOut = () => {
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API_LINK}/${Endpoints.SignOut}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("token")
            }
        }).then(function () {
            ClearTokens();
            localStorage.removeItem("initialUrl");
            const redirect_uri = window.location.origin;
            window.location.href = `${process.env.REACT_APP_SSO_LINK}/Logout?post_logout_redirect_uri=${redirect_uri}/login`;
        });
    }

    useEffect(() => {
        signOut();
    }, []);

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <div className="sweet-loading" style={{ textAlign: 'center' }}>
                <div>
                    <img src="/media/logos/yanmenu.png" alt="Logo" className='img-fluid' />
                </div>

                <div className='mt-20'>
                    <span style={{ fontSize: '24px' }}>Çıkış yapılıyor, lütfen bekleyin...</span>
                </div>

                <div className='mt-10'>
                    <BarLoader color="#000787" loading={true} cssOverride={{
                        display: "block",
                        margin: "0 auto",
                        borderColor: "gray"
                    }} />
                </div>
            </div>
        </div>
    )
}

export { Logout }